import { createAutoCorrectedDatePipe } from 'text-mask-addons';

const CVC_MIN_LENGTH = 3;
const CVC_MAX_LENGTH = 4;

function ngxCvcMask(value: string = ''): string {
  const len = value.length < CVC_MAX_LENGTH ? CVC_MIN_LENGTH : CVC_MAX_LENGTH;

  return '0'.repeat(len);
}

export interface TextMasks {
  [key: string]: any;
}

export const SharedMasks: TextMasks = {

  phoneMask: {
    guide: false,
    placeholderChar: '\u2000',
    ngxMask: '(000) 000-0000'
  },

  expirationMask: {
    pipe: createAutoCorrectedDatePipe('mm/yy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
    ngxMask: '00/00'
  },

  birthdayMask: {
    pipe: createAutoCorrectedDatePipe('mm/dd/yyyy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
    ngxMask: '00/00/0000'
  },

  cvcMask: {
    guide: false,
    placeholderChar: '\u2000',
    ngxMask: ngxCvcMask
  },

  zipcodeMask: {
    guide: false,
    placeholderChar: '\u2000',
    ngxMask: '00000'
  }
};
